import BoxListButton from "@components/BoxListButton";
import { NEWS_DETAIL, NEWS_MODIFY } from "@constants/routes";
import { timestampToString } from "@helpers/dates.format";
import { INews } from "@interfaces/news";

const listNewsMapper = (items: INews[], handleDelete: Function) =>
  items.map(({ uuid, title, date, summary, body, createdAt, updatedAt }) => ({
    uuid,
    title,
    date: timestampToString(date),
    _dateTs: date ?? 0,
    summary,
    body,
    createDate: timestampToString(createdAt),
    _createDateTs: createdAt ?? 0,
    updateDate: timestampToString(updatedAt),
    _updateDateTs: updatedAt ?? 0,
    actions: (
      <BoxListButton
        uuid={uuid}
        description={title}
        detailRoute={NEWS_DETAIL}
        modifyRoute={NEWS_MODIFY}
        handleDelete={handleDelete}
      />
    ),
  }));

export default listNewsMapper;
